import InfoIndicator from './InfoIndicator';

export default InfoIndicator;
